import Check from '@mui/icons-material/Check';
import ContentCopy from '@mui/icons-material/ContentCopy';
import { Button, Tooltip } from '@mui/material';
import type React from 'react';
import { useState } from 'react';
import { useSnackbar } from '../../contexts/SnackbarContext';

interface Props {
  textToCopy: string;
}

const CopyButton: React.FC<Props> = ({ textToCopy }) => {
  const [copied, setCopied] = useState(false);
  const { showSnackbar } = useSnackbar();

  const handleCopy = async () => {
    if (!textToCopy) {
      return;
    }
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      showSnackbar('Copied to clipboard!', 'success');
      setTimeout(() => setCopied(false), 2500); // Reset after 2.5 seconds
    } catch (_err) {
      showSnackbar('Failed to copy text.', 'error');
    }
  };

  return (
    <Tooltip title={copied ? 'Copied!' : 'Copy to clipboard'}>
      <Button
        onClick={handleCopy}
        size="small"
        aria-label="Copy to clipboard"
        sx={{
          minWidth: 'auto',
          padding: '4px',
          color: copied ? 'success.main' : 'text.primary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        {copied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
      </Button>
    </Tooltip>
  );
};

export default CopyButton;
